import { gql } from '@apollo/client';

export interface UserMarkerType {
  id: number;
  createdAt: string;
  updatedAt: string;
  accountId: number;
  type: number;
  value: string;
}

export const GET_MARKER_LIST_BY_ACCOUNT_ID_AND_TYPE = gql`
  query GetMarkerListByAccountIdAndType($accountId: Long!, $type: Int!) {
    findByAccountIdAndType(accountId: $accountId, type: $type) {
      id
      createdAt
      updatedAt
      accountId
      type
      value
    }
  }
`;

export interface GetMarkerListByAccountIdAndTypeResponse {
  findByAccountIdAndType: UserMarkerType[];
}
